import { Alert } from './alert-container';

export default Alert;
